export default __webpack_public_path__ + "static/MyM-loader-e96738956543e4c638d4bc9af739d305.gif";